var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBillingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9.898C3.5 8.87292 3.5 8.36038 3.70266 7.97025C3.87343 7.64149 4.14149 7.37343 4.47025 7.20266C4.86038 7 5.37292 7 6.398 7H17.602C18.6271 7 19.1396 7 19.5298 7.20266C19.8585 7.37343 20.1266 7.64149 20.2973 7.97025C20.5 8.36038 20.5 8.87292 20.5 9.898V16.102C20.5 17.1271 20.5 17.6396 20.2973 18.0298C20.1266 18.3585 19.8585 18.6266 19.5298 18.7973C19.1396 19 18.6271 19 17.602 19H6.398C5.37292 19 4.86038 19 4.47025 18.7973C4.14149 18.6266 3.87343 18.3585 3.70266 18.0298C3.5 17.6396 3.5 17.1271 3.5 16.102V9.898Z",
    fill: "white",
    fillOpacity: 0.1,
    stroke: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11L20.5 11",
    stroke: "#000000",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 16,
    r: 0.5,
    fill: "#000000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingIcon);
export default __webpack_public_path__ + "static/media/billingIcon.ad1bead6c28bf3d681216f9b2b975425.svg";
export { ForwardRef as ReactComponent };